// slider js start here 



if (!customElements.get('swiper-slideshow')) {
  customElements.define('swiper-slideshow', class SwiperSlideShow extends HTMLElement {

    constructor() {
      super();

      this.slider = null;
      this.sliderWrapper = null;
    }

    connectedCallback() {
      this.sliderWrapper = this.querySelector(".swiper__slideshow");

      if (!this.sliderWrapper) return;

      this.optionsData = this.sliderWrapper.dataset.option
        ? JSON.parse(this.sliderWrapper.dataset.option)
        : {};

      this.initSlider();
    }

    initSlider() {
      if (this.slider) return;

      const next = this.querySelector(".arrow-next-button");
      const prev = this.querySelector(".arrow-prev-button");
      const paginationEl = this.querySelector(".swiper-pagination");
      const scrollbar = this.querySelector(".swiper-scrollbar");

      const defaults = {
        effect: "slide",
        slidesPerView: 1,
        watchOverflow: true,
        speed: 700,
        loop: false,

        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },

        navigation: {
          nextEl: next,
          prevEl: prev
        },

        scrollbar: {
          el: scrollbar,
          draggable: true
        }
      };

      const options = {
        ...defaults,
        ...this.optionsData
      };

      if (this.optionsData.enablePagination && paginationEl) {
        options.pagination = {
          el: paginationEl,
          clickable: true
        };
      }

      this.slider = new Swiper(
        this.sliderWrapper,
        options
      );
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }
  });
}




// slider js end here 



document.addEventListener('DOMContentLoaded', function () {

  const headers = document.querySelectorAll('.evo-header');

  headers.forEach(function (header) {

    /* =====================================================
       MOBILE / TABLET DRAWER
    ===================================================== */

    const menuToggle = header.querySelector('.evo-header__menu-toggle');
    const drawer = header.querySelector('.evo-header__drawer');
    const drawerClose = header.querySelector('.evo-header__drawer-close');
    const drawerOverlay = header.querySelector('.evo-header__drawer-overlay');

    if (menuToggle && drawer) {

      const openDrawer = function () {

        drawer.classList.add('is-open');

        drawer.setAttribute('aria-hidden', 'false');

        menuToggle.setAttribute('aria-expanded', 'true');

        document.documentElement.classList.add('evo-drawer-open');

        document.body.classList.add('evo-drawer-open');
      };


      const closeDrawer = function () {

        drawer.classList.remove('is-open');

        drawer.setAttribute('aria-hidden', 'true');

        menuToggle.setAttribute('aria-expanded', 'false');

        document.documentElement.classList.remove('evo-drawer-open');

        document.body.classList.remove('evo-drawer-open');
      };


      menuToggle.addEventListener('click', openDrawer);


      if (drawerClose) {
        drawerClose.addEventListener('click', closeDrawer);
      }


      if (drawerOverlay) {
        drawerOverlay.addEventListener('click', closeDrawer);
      }


      document.addEventListener('keydown', function (event) {

        if (event.key === 'Escape') {
          closeDrawer();
        }

      });


      /* ===============================================
         DRAWER SUBMENUS
      =============================================== */

      const submenuButtons =
        header.querySelectorAll(
          '.evo-header__drawer-submenu-toggle'
        );


      submenuButtons.forEach(function (button) {

        button.addEventListener('click', function () {

          const submenu =
            button
              .closest('.evo-header__drawer-item')
              .querySelector('.evo-header__drawer-submenu');


          const isOpen =
            button.getAttribute('aria-expanded') === 'true';


          button.setAttribute(
            'aria-expanded',
            String(!isOpen)
          );


          button.classList.toggle(
            'is-open',
            !isOpen
          );


          if (submenu) {

            submenu.classList.toggle(
              'is-open',
              !isOpen
            );

          }

        });

      });

    }



    /* =====================================================
       PROMO SLIDER
    ===================================================== */

    const promoTrack =
      header.querySelector('.evo-header__promo-track');

    const promoItems =
      header.querySelectorAll('.evo-header__promo-item');

    const prevButton =
      header.querySelector('.evo-header__promo-arrow--prev');

    const nextButton =
      header.querySelector('.evo-header__promo-arrow--next');


    if (
      promoTrack &&
      promoItems.length > 1 &&
      prevButton &&
      nextButton
    ) {

      let currentSlide = 0;

      let autoSlide;


      const isMobileSlider = function () {

        return window.matchMedia(
          '(max-width: 1249px)'
        ).matches;

      };


      const goToSlide = function (index) {

        if (!isMobileSlider()) {
          return;
        }


        if (index < 0) {
          index = promoItems.length - 1;
        }


        if (index >= promoItems.length) {
          index = 0;
        }


        currentSlide = index;


        const item = promoItems[currentSlide];

        promoTrack.scrollTo({
          left: item.offsetLeft,
          behavior: 'smooth'
        });

      };


      const nextSlide = function () {

        goToSlide(currentSlide + 1);

      };


      const previousSlide = function () {

        goToSlide(currentSlide - 1);

      };


      nextButton.addEventListener(
        'click',
        function () {

          nextSlide();

          restartAutoSlide();

        }
      );


      prevButton.addEventListener(
        'click',
        function () {

          previousSlide();

          restartAutoSlide();

        }
      );


      const startAutoSlide = function () {

        if (!isMobileSlider()) {
          return;
        }


        autoSlide = setInterval(
          function () {

            nextSlide();

          },
          5000
        );

      };


      const stopAutoSlide = function () {

        if (autoSlide) {

          clearInterval(autoSlide);

          autoSlide = null;

        }

      };


      const restartAutoSlide = function () {

        stopAutoSlide();

        startAutoSlide();

      };


      const handleResize = function () {

        stopAutoSlide();

        currentSlide = 0;


        if (isMobileSlider()) {

          startAutoSlide();

        }

      };


      handleResize();


      window.addEventListener(
        'resize',
        handleResize
      );


      /* Pause while touching */

      promoTrack.addEventListener(
        'touchstart',
        stopAutoSlide,
        { passive: true }
      );


      promoTrack.addEventListener(
        'touchend',
        function () {

          restartAutoSlide();

        },
        { passive: true }
      );

    }

  });

});